// extracted by mini-css-extract-plugin
export default {"submitBtn":"Q22v5PGg8yOOxlS0mcE1","errorMessage":"Zu3sw8Cr5MU2R3Irocm9"};